const positions = new Map();
const limit = 500;

export function savePlaybackPosition(key, time, duration, ended = false) {
  if (!key || !Number.isFinite(time) || !Number.isFinite(duration) || duration <= 0) return;
  positions.delete(key);
  positions.set(key, ended ? 0 : Math.max(0, Math.min(time, duration)));
  if (positions.size > limit) positions.delete(positions.keys().next().value);
}

export function getPlaybackPosition(key, fallback = 0) {
  return positions.get(key) ?? (Number.isFinite(fallback) && fallback >= 0 ? fallback : 0);
}
